<template>
  <span class="badge">
    <vs-chip :color="enabled ? 'success' : 'danger'">
      <feather-icon :icon="enabled ? 'CheckIcon' : 'XIcon'" class="w-4 h-4"></feather-icon>
    </vs-chip>
  </span>
</template>

<script>
export default {
  name: 'BadgeEnabled',
  props: {
    enabled: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style lang="scss">

</style>
